<template>
  <v-layout hvf-multi-exam-container>
    <v-flex hvf-multi-exam-sidebar escalon-col2>
      <hvf-multi-sidebar-block
        v-for="(view, index) in hvfViews"
        :key="index"
        :view="view"
        :index="index"
        :controlSize="controlSize"
        :image="firstOSImage"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @scrollUp="scrollUp"
        @scrollDown="scrollDown"
        @scrollTo="scrollTo"/>
    </v-flex>
    <v-flex hvf-multi-exam-image-container escalon-col9>
      <hvf-multi-image-block
        v-for="(view, index) in hvfViews"
        :key="index"
        :view="view"
        :index="index"
        :canvasSize="canvasSize"
        :scroll="scroll"
        @hvf_mousedown="mousedown"
        @hvf_mousemove="mousemove"
        @hvf_mouseup="mouseup"
        @scrollUp="scrollUp"
        @scrollDown="scrollDown"
        @next="nextHVFImage"
        @prev="previousHVFImage"/>
    </v-flex>
  </v-layout>
</template>

<script>
import hvfMultiSidebarBlock from "./HVFMultiSidebarBlock";
import hvfMultiImageBlock from "./HVFMultiImageBlock";
import responsiveCanvases from "../../mixins/ResponsiveCanvases";
import hvfPositioning from "../../mixins/HVFPositioning";
import { mapWatchers } from "../../../helpers/utils";
import { defaultSize} from "../../../canvas/geometry";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "hvfMultiExamContainer",
  components: { hvfMultiSidebarBlock, hvfMultiImageBlock },
  mixins: [responsiveCanvases, hvfPositioning],
  computed: {
    ...mapGetters(["hvfViews"]),
    firstOSImage(){
      let firstView = this.hvfViews[0];
      return firstView && firstView.osImage;
    },
    imgSize() {
      return this.firstOSImage && this.firstOSImage.imgSize || defaultSize();
    }
  },
  methods: {
    ...mapMutations(["previousHVFImage", "nextHVFImage"])
  },
  watch: {
    ...mapWatchers(["imgSize", "hvfViews"], function() {
      this.resetView(this._uid);
    })
  },
  mounted() {
    this.resetView(this._uid);
  }
};
</script>